<ul class="sub-menu-v2--dropdown">
    <ng-container *ngFor="let integration of integrations">
        <li *ngIf="integration.status.state !== 'NotConnected' && integration.status.state !== 'Unavailable'">
            <!-- Title of the integration -->
            <label
                class="integrations-connection"
                [ngClass]="{
                    'integrations-connection--active': integration.status.state === 'Connected' || integration.status.state === 'Running',
                    'integrations-connection--alert': integration.status.state === 'Error' || integration.status.state === 'Attention',
                }"
                >{{ integration.name }}</label
            >
            <!-- Each integration can typically have 1 or more actions depending on the state -->
            <div class="button-badge-wrapper" *ngFor="let action of integration.actions">
                <!-- Show when sync needed -->
                <button
                    class="btn btn-success-nav-v2"
                    type="button"
                    title="{{ action.details }}"
                    *ngIf="integration.status.state !== 'Error' && integration.status.state !== 'Attention'"
                    [disabled]="!action.available || isAccountSyncing"
                    (click)="doAction(integration, action)"
                    [ngClass]="{ 'button  is-loading': isAccountSyncing }">
                    {{ isAccountSyncing ? '' : action.name }}
                </button>

                <span
                    title="{{ integration.status.notificationDetails }}"
                    class="badge pull-right badge-danger badge--integrations"
                    *ngIf="
                        integration.status.notifications && integration.status.state !== 'Error' && integration.status.state !== 'Attention'
                    "
                    >{{ integration.status.notifications }}</span
                >

                <!-- Or this if any errors -->

                <button
                    class="btn btn-error-nav-v2"
                    title="{{ integration.status.stateDetails }}"
                    type="button"
                    *ngIf="integration.status.state === 'Error' || integration.status.state === 'Attention'"
                    [routerLink]="['/account', 'integrations']">
                    Details
                </button>
            </div>
        </li>
    </ng-container>
</ul>
